// @flow

type CustomEventPayload = {
  [string]: any
}

export function dispatchChatchampEvent (type: string, event: CustomEventPayload) {
  window.dispatchEvent(new window.CustomEvent(type, { detail: event }))
}
